import axios from 'axios';
import apiLogger from '../apiLogger';
import axiosRetry from 'axios-retry';
import { curlInterceptor } from 'curl2axios';
import { OPEN_AI_BASE_URL, OPEN_AI_ENDPOINTS, OPEN_AI_AUTHERIZATION } from './OPEN_AI_constant';

export const OPEN_AI_axios_adapter = axios.create({
    baseURL: OPEN_AI_BASE_URL,
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `${OPEN_AI_AUTHERIZATION}`,
    },
});

const myCallback = (curl) => {
    console.log(curl);
};

OPEN_AI_axios_adapter.interceptors.request.use((req) => curlInterceptor(req, myCallback));

axiosRetry(OPEN_AI_axios_adapter, {
    retries: 1,
    retryDelay: (retryCount) => retryCount * 1000,
    retryCondition: (error) => {
        return axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response?.status >= 500;
    },
});

OPEN_AI_axios_adapter.interceptors.request.use(
    (config) => {
        //config.headers['Authorization'] = `${OPEN_AI_AUTHERIZATION}`;
        config.metadata = { startTime: new Date().getTime() };
        return apiLogger.request(config);;
    },
    (error) => {
        return apiLogger.error(error);
    }
);

OPEN_AI_axios_adapter.interceptors.response.use(
    (response) => {
        const endTime = new Date().getTime();
        const duration = endTime - response.config.metadata.startTime; // ⏱️ Duration in ms
        response.duration = duration; // Attach to response
        return apiLogger.response(response);
    },
    (error) => {
        if (error.config && error.config.metadata) {
            const endTime = new Date().getTime();
            const duration = endTime - error.config.metadata.startTime;
            error.duration = duration; // Attach to error
            console.log(`❌ Request failed after ${duration} ms`);
        }
        return apiLogger.error(error);
    }
);
